import styled from 'styled-components';
import { faInstagram, faFacebookF } from '@fortawesome/fontawesome-free-brands';

import CircleIcon from '../shared/CircleIcon';
import { GREY_COLOR, TABLET_SIZE } from '../../constants';

const Container = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: ${TABLET_SIZE}) {
    text-align: center;
    margin: 30px;
  }
`;

const SocialIcons = () => (
  <Container>
    <a href="https://www.instagram.com/inventi.cz" aria-label="Instagram">
      <CircleIcon
        color={GREY_COLOR}
        icon={faInstagram}
        size="lg"
        margin="0 5px 0 0"
        hasHover
      />
    </a>
    <a href="https://www.facebook.com/inventi.cz" aria-label="Facebook">
      <CircleIcon
        color={GREY_COLOR}
        icon={faFacebookF}
        size="lg"
        margin="0 0 0 5px"
        hasHover
      />
    </a>
  </Container>
);

export default SocialIcons;



// WEBPACK FOOTER //
// components/Footer/SocialIcons.js